export default "__VITE_ASSET__C76PYMUI__"